<template>
  <v-text-field
    ref="textField"
    :value="formattedDispatchLimit"
    class="dispatch-input"
    dense
    outlined
    :disabled="disabled"
    :suffix="suffix"
    :hint="hint"
    :persistent-hint="persistentHint"
    :error="error"
    :rules="[numberRule]"
    :error-messages="errorMessages"
    @input="unformatDispatchLimit"
    @keydown="preventNonNumericInput"
    @blur="formatOnBlur"
  />
</template>

<script>
export default {
  name: 'DispatchLimitInput',
  model: {
    prop: 'dispatchLimit',
    event: 'input',
  },
  props: {
    dispatchLimit: {
      type: Number,
      required: true,
    },
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    suffix: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [Array, String],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedDispatchLimit() {
      return this.localeString(this.dispatchLimit, 0)
    },
  },
  methods: {
    preventNonNumericInput(event) {
      const keyPressed = event.key
      const isControlKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(keyPressed)
      const inputLength = event.target.value.length
      const isFullSelection = event.target.selectionStart === 0 && event.target.selectionEnd === inputLength

      if (isControlKey) {
        return
      }
      if (!/^\d$/.test(keyPressed)) {
        event.preventDefault()
        return
      }
      if (isFullSelection) {
        return
      }
      if (inputLength >= 8) {
        event.preventDefault()
      }
    },
    unformatDispatchLimit(value) {
      const numericValue = value.replace(/\D/g, '')
      this.$emit('input', parseInt(numericValue || '0', 10))
    },
    numberRule(value) {
      const rawValue = value.replace(/\./g, '')
      return /^\d*$/.test(rawValue) || 'Apenas números são permitidos'
    },
    formatOnBlur(event) {
      const numericValue = event.target.value.replace(/\D/g, '')
      this.$nextTick(() => {
        this.$refs.textField.lazyValue = this.localeString(numericValue, 0)
      })
      this.$emit('blur', event)
    },
  },
}
</script>

<style lang="scss" scoped>
.dispatch-input {
  max-width: 240px;

  ::v-deep .v-text-field__suffix {
    color: $cinza-l30;
    font-size: 14px;
  }
}
</style>
